import * as React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { postMessageToParent } from '../../utils/postMessage';
import { PAYMENT_STATUS, POST_MESSAGE_TYPE } from '../../common/constants';
import { useSelector } from "react-redux";
import { persistor } from '../../utils/store';

export default function ReturnToStoreButton(props) {
  const {t} = useTranslation();
  const { sourceOrigin } = useSelector((state) => state.paymentClient);

  ReturnToStoreButton.propTypes = {
    reasonMessage: PropTypes.string
  };

  const handleReturnToStore = () => {
    postMessageToParent({
      type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
      content: {
        status: PAYMENT_STATUS.FAIL,
        message: props.reasonMessage
      },
      sourceOrigin: sourceOrigin
    });

    persistor.purge();
  };

  return(
    <button type="button" className="mpi-button-cancel2" onClick={handleReturnToStore}>
      {t('pay.gsmpi.return.button')}
    </button>
  );
}